import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, DatePicker, Button, Icon } from 'antd';
import util from '../../util';
import EcodeEmpty from './EcodeEmpty';
const { getPermissions } = util;

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const store = [
  'devStore'
]
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-dev-content'
  }
  componentDidMount() {
  }

  /**
   * 提交表单
   */
  submit = () => {
    const { devStore: { getDevelopKey }, form } = this.props;
    const { validateFields, resetFields } = form;
    validateFields((errors, values) => {
      if(!errors) {
        values = {
          ...values,
          expireDate: values.expireDate.format('YYYY-MM-DD'),
        }
        getDevelopKey(values).then(() => resetFields())
      }
    })
  }

  render() {
    const { prefixCls, form, devStore: { developKeyLoading, developKey } } = this.props;
    const { getFieldDecorator, resetFields } = form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    if(getPermissions()) return <EcodeEmpty />;
    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-form`}>
          <Form {...formItemLayout}>
            <FormItem
              label="AppID"
            >
              {
                getFieldDecorator("appId", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: 'AppID不能为空',
                    },
                  ],
                })(<Input />)
              }
            </FormItem>
            <FormItem
              label="订单号"
            >
              {
                getFieldDecorator("orderNum", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: '订单号不能为空',
                    },
                  ],
                })(<Input />)
              }
            </FormItem>
            <FormItem
              label="标识码"
            >
              {
                getFieldDecorator("authKey", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: '标识码不能为空',
                    },
                  ],
                })(<TextArea autoSize={{minRows: 4, maxRows: 4}} />)
              }
            </FormItem>
            <FormItem
              label="有效期(截止到)"
            >
              {
                getFieldDecorator("expireDate", {
                  // initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: '有效期不能为空',
                    },
                  ],
                })(<DatePicker className={`${prefixCls}-date`} />)
              }
            </FormItem>
            <FormItem wrapperCol={{span: 24}} className={`${prefixCls}-btns`}>
              <Button onClick={() => resetFields()}>重置</Button>
              <Button type="primary" onClick={this.submit}>提交</Button>
            </FormItem>
          </Form>
        </div>
        <div className={`${prefixCls}-authorization-code`}>
          {
            developKeyLoading 
              ? <Icon type="loading" />
              : developKey ? 
                <span>
                  <h2 className={`${prefixCls}-authorization-code-title`}>授权码：</h2>
                  <div className={`${prefixCls}-authorization-code-content`}>{developKey}</div>
                </span> : null
          }
        </div>
      </div>
    )
  }
}

App = Form.create()(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/dev/Development.js